import Styles from './WizardCategoryCard.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import React, { useState } from 'react'
import cx from 'classnames'
import { Pressable, PressProps } from '@react-aria/interactions'
import { Text } from 'blaze-ui/Text/Text'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'

interface WizardPopularBannerProps extends PressProps {
  image: string
  title: string
  description: string
  variant: 'blog' | 'ads'
  actions?: React.ReactNode
}

export const WizardPopularBanner = ({
  onPress,
  image,
  title,
  description,
  actions,
  variant,
}: WizardPopularBannerProps) => {
  const [isLoaded, setIsLoaded] = useState(false)

  return (
    <Pressable onPress={onPress}>
      <div
        className={cx(Styles.wizardPopularBanner, Styles[variant])}
        style={{
          backgroundImage: isLoaded && image ? `url(${image})` : undefined,
        }}
      >
        <div className={Styles.textContainer}>
          <Heading level={3} color={variant === 'ads' ? 'var(--light-100)' : undefined}>
            {title}
          </Heading>
        </div>
        <div className={Styles.description}>
          <Text variant="secondary" color={variant === 'ads' ? 'var(--light-90)' : undefined}>
            {description}
          </Text>
        </div>
        <div className={Styles.actions}>{actions}</div>
        <div className={Styles.imageContainer}>
          {image && (
            <>
              {!isLoaded && <LoadingShimmerer className={Styles.shimmerer} />}
              <img src={image} alt="" style={{ display: 'none' }} onLoad={() => setIsLoaded(true)} />
            </>
          )}
        </div>
      </div>
    </Pressable>
  )
}

type WizardCategoryCardGridProps = {
  children: React.ReactNode
  heading?: string
  button?: React.ReactNode
  variant?: 'default' | 'popular'
}

export const WizardCategoryCardGrid = ({
  children,
  heading,
  button,
  variant = 'default',
}: WizardCategoryCardGridProps): React.ReactElement => {
  return (
    <div className={cx(Styles.WizardCategoryCardGridContainer, Styles[variant])}>
      {heading && (
        <div className={Styles.heading}>
          <Heading level={3}>{heading}</Heading>
          {button}
        </div>
      )}
      <div className={Styles.wizardCategoryCardGrid}>{children}</div>
    </div>
  )
}
